module.exports = __webpack_public_path__ + "static/img/sd.957f751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/sd.jpg
// module id = 00jg
// module chunks = 21